import React, { Component } from 'react';
import { array, arrayOf, bool, func, number, object, oneOfType, shape, string } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import AlertMessage from '../../AlertMessage/AlertMessage';
import CompSetEditModal from './CompSetEditModal';
import CompSetsTile from './CompSetsTile';
import * as compSetActions from './reducers/competitiveSets';
import { getJobFamilyListForSet } from '../AddJob/reducers/jobFamilies';
import './CompetitiveSets.scss';

const ALERT_MESSAGE =
  'This competitive set will be removed from all associated jobs, and pricing for those jobs will be recalculated.';
const PAGE_TITLE = 'Competitive Sets';

export class CompetitiveSetsPage extends Component {
  static propTypes = {
    actions: shape({
      addSet: func,
      cancelDeleteAlert: func,
      changeSetValue: func,
      closeEditSet: func,
      deleteAlert: func,
      deleteSet: func,
      editSet: func,
      getCompSets: func,
      getIndustryOptions: func,
      getJobFamilyListForSet: func,
      getOrgType: func,
      saveSet: func
    }),
    competitiveSets: shape({
      currentEditSet: oneOfType([
        bool,
        shape({
          competitive_set_pk: number,
          competitive_set_name: string,
          creator_user_id: oneOfType([string, number]),
          creation_time: string,
          last_modifying_user_id: oneOfType([string, number]),
          last_modifying_user_name: string,
          company_type: string,
          employees_count: number,
          total_revenue: number,
          industry: array,
          government_contractor: bool,
          default_job_families: arrayOf(
            shape({
              label: string,
              value: string
            })
          ),
          job_family_list: arrayOf(
            shape({
              label: string,
              value: string
            })
          )
        })
      ]),
      items: arrayOf(
        shape({
          competitive_set_pk: number,
          competitive_set_name: string,
          creator_user_id: oneOfType([string, number]),
          creation_time: string,
          last_modifying_user_id: oneOfType([string, number]),
          last_modifying_user_name: string,
          company_type: string,
          employees_count: number,
          total_revenue: number,
          industry: array,
          government_contractor: bool,
          default_job_families: arrayOf(
            shape({
              label: string,
              value: string
            })
          ),
          job_family_list: arrayOf(
            shape({
              label: string,
              value: string
            })
          )
        })
      ),
      orgTypes: arrayOf(
        shape({
          label: string,
          value: string
        })
      ),
      saving: bool,
      showDeleteAlert: bool,
      validation: shape({
        isValid: bool,
        noChange: bool
      })
    }),
    jobFamilies: shape({
      error: string,
      items: arrayOf(
        shape({
          label: string,
          value: string
        })
      ),
      loaded: bool,
      loading: bool
    })
  };

  constructor(props) {
    super(props);
    this.state = { jobFamilies: [] };

    this.addSet = this.addSet.bind(this);
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.getCompSets();
  }

  componentDidUpdate(prevProps) {
    const { actions, jobFamilies } = this.props;

    if (jobFamilies.loaded !== prevProps.jobFamilies.loaded) {
      actions.addSet(jobFamilies.items);
    }
  }

  addSet() {
    const { actions } = this.props;

    actions.getJobFamilyListForSet();
  }

  render() {
    const { actions, competitiveSets } = this.props;
    const isLab = window.app.basicProductName !== 'MarketPay';
    const rows = [];
    for (let i = 0; i < competitiveSets.items.length; i += 2) {
      const items = competitiveSets.items;
      rows.push([items[i], items[i + 1]]);
    }

    return (
      <div
        className={`container-fluid page__container compsets__page-container ${
          isLab ? 'compsets-lab' : 'compsets-mp'
        } `}
      >
        <HelmetProvider>
          <Helmet title={'Competitive Sets - PayScale'} />
        </HelmetProvider>

        <div className="row">
          <div className="col-md-12">
            <h4 className="compsets__page-title">
              {PAGE_TITLE}
              <span
                className="icon-border icon-circle-thin pointer editLink--green compsets__addIcon showIcon"
                onClick={this.addSet}
              >
                <i className="icon-plus" />
              </span>
            </h4>
          </div>
        </div>
        {rows &&
          rows.map(row => {
            return (
              <div className="row compsets__tile-row" key={row[0].competitive_set_pk}>
                <div className="col-md-6">
                  <CompSetsTile
                    data={row[0]}
                    editSet={actions.editSet}
                    getJobFamilyListForSet={actions.getJobFamilyListForSet}
                    deleteAlert={actions.deleteAlert}
                  />
                </div>
                <div className="col-md-6">
                  <CompSetsTile
                    data={row[1]}
                    editSet={actions.editSet}
                    getJobFamilyListForSet={actions.getJobFamilyListForSet}
                    deleteAlert={actions.deleteAlert}
                  />
                </div>
              </div>
            );
          })}

        <AlertMessage
          actions={{ confirm: actions.deleteSet, cancel: actions.cancelDeleteAlert }}
          data={competitiveSets.compSetDataToDelete}
          message={ALERT_MESSAGE}
          show={competitiveSets.showDeleteAlert}
          title="Warning"
        />
        {competitiveSets.currentEditSet && (
          <CompSetEditModal
            changeSetValue={actions.changeSetValue}
            closeEditSet={actions.closeEditSet}
            compSets={competitiveSets}
            getIndustryOptions={actions.getIndustryOptions}
            getOrgType={actions.getOrgType}
            isLab={isLab}
            saveSet={actions.saveSet}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ competitiveSets, jobFamilies }) => {
  return {
    competitiveSets,
    jobFamilies
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...compSetActions, getJobFamilyListForSet }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CompetitiveSetsPage);
